import { Pipe, PipeTransform } from '@angular/core';
import { TableFilterOptionValue } from '../table.component';
import { TABLE_MODE } from '../../../enums/TableMode.enum';

@Pipe({
  name: 'selectedFilterOptions',
  standalone: true,
})
export class SelectedFilterOptionsPipe implements PipeTransform {
  transform(
    column: string,
    mode: TABLE_MODE,
    serverFilters: { key: string; values: TableFilterOptionValue[] }[],
    filters: { [key: string]: { options: TableFilterOptionValue[] } },
  ): TableFilterOptionValue[] {
    if (mode === TABLE_MODE.SERVER) {
      return serverFilters.find(filter => filter.key === column)?.values ?? [];
    }
    return filters[column]?.options ?? [];
  }
}
